import { put, call, take, fork } from 'redux-saga/effects'
import { LLMSendChatMessageService } from '../../api/llm'
import { llmSendChatMessageSuccess } from '../../reducers/llm/action'
import { SEND_CHAT_MESSAGE } from '../../reducers/llm/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* sendChatMessageFlow(payload) {
  try {
    const { chatData, callback } = payload

    const response = yield call(LLMSendChatMessageService, chatData)

    yield put(llmSendChatMessageSuccess(response.data))
    yield put(operationSuccess())

    callback(response.data)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* sendChatMessageWatcher() {
  while (true) {
    const action = yield take(SEND_CHAT_MESSAGE)
    const { payload } = action

    yield fork(generalSaga, sendChatMessageFlow, payload, false)
  }
}
